import React, {FunctionComponent, MouseEvent, SVGProps} from 'react';

import {lighten} from 'polished';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import {ReactComponent as AlcoholIcon} from 'assets/svg/alcohol.svg';
import {ReactComponent as BiofuelsIcon} from 'assets/svg/biofuels.svg';
import {ReactComponent as CoffeeIcon} from 'assets/svg/coffee.svg';
import {ReactComponent as DrinkIcon} from 'assets/svg/drink.svg';
import {ReactComponent as DrugIcon} from 'assets/svg/drug.svg';
import {ReactComponent as FuelIcon} from 'assets/svg/fuel.svg';
import {ReactComponent as TobaccoIcon} from 'assets/svg/tobacco.svg';
import {ReactComponent as VetIcon} from 'assets/svg/vet.svg';
import {Icon} from 'components/ui-kit/Icon';
import {ContentColumnText} from 'components/ui-kit/PageComponents/ContentColumns/styled';
import {ProductGroup, ProductGroups} from 'core/constants/productGroups';
import {colors} from 'theme';

type Props = {
    value: ProductGroup;
    width?: number;
    onClick?: (event: MouseEvent) => void;
    label?: boolean;
    style?: React.CSSProperties;
};

export const ProductGroupIcon = ({
    value,
    onClick,
    width = 16,
    label,
    style,
}: Props): JSX.Element => {
    const {t} = useTranslation();
    let source: FunctionComponent<SVGProps<SVGSVGElement>> | null = null;
    switch (value) {
        case ProductGroups.TOBACCO:
            source = TobaccoIcon;
            break;
        case ProductGroups.ALCOHOL:
            source = AlcoholIcon;
            break;
        case ProductGroups.MEDICATIONS:
            source = DrugIcon;
            break;
        case ProductGroups.VETERINARY:
            source = VetIcon;
            break;
        case ProductGroups.DRINKS:
            source = DrinkIcon;
            break;
        case ProductGroups.COFFEE:
            source = CoffeeIcon;
            break;
        case ProductGroups.FUEL:
            source = FuelIcon;
            break;
        case ProductGroups.BIOFUELS:
            source = BiofuelsIcon;
            break;
    }
    return source ? (
        <ContentColumnText
            highlighted
            thin
            style={{display: 'flex', alignItems: 'center', ...style}}
        >
            <ProductIcon
                source={source}
                fillColor={colors.brandPrimary}
                onClick={onClick}
                width={width}
            />
            {label && <span>{t(`dictionaries.productGroups.${value}`)}</span>}
        </ContentColumnText>
    ) : (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <span onClick={onClick}>{'—'}</span>
    );
};

export const ProductIcon = styled(Icon)<{width: number}>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(p) => p.width * 2}px;
    height: ${(p) => p.width * 2}px;
    border-radius: 4px;
    //background-color: ${lighten(0.35, colors.brandPrimary)};
`;
